<template>
  <div id="home">
    <Header></Header>
    <div class="topBanner">
      <ul class="row to-top" v-if="isToTop">
        <li>
          <div class="title column first">功能</div>
          <div v-for="item in contrasTitleList" :key="item.name" :class="'column ' + item.class">
            <div class="title-box">
              <p class="title">{{ item.name }}</p>
              <p v-if="item.des" class="des">{{ item.des }}</p>
            </div>
            <p class="price">
              ¥<span class="num">{{ item.price }}</span
              >/ <span class="unit">年</span>
            </p>
            <div class="btn" @click="payMenberFun(item.class)">
              <div class="mark"></div>
              {{ !item.vip ? item.text : '立即续费' }}
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="warpper1">
      <p class="title">成为迷你CAD会员</p>
      <p class="des">解锁软件所有功能，绘图更轻松，效率更出色</p>
      <ul class="member-list">
        <li v-for="item in menberListAll" :key="item.name" :class="item.class">
          <div class="tips" v-if="item.vip">已开通</div>
          <div class="top">
            <svg-icon :name="item.class" class="svg-icon"></svg-icon>
            <p class="name">{{ item.name }}</p>
            <p class="price">
              ¥<span class="num">{{ item.price }}</span
              >/<span class="unit">年</span>
            </p>
            <div class="btn" @click="payMenberFun(item.class)">
              <div class="mark"></div>
              {{ !item.vip ? item.text : '立即续费' }}
            </div>
          </div>
          <ul class="bottom" v-if="!item.vip">
            <li v-for="l in item.desList" :key="l">
              <svg-icon name="right" class="svg-icon"></svg-icon>
              <span>{{ l }}</span>
            </li>
          </ul>
          <ul class="bottom" v-else>
            <li>开通时间: {{ item.times.start_time }}</li>
            <li>到期时间: {{ item.times.end_time }}</li>
            <li>剩余时间: {{ item.times.remaining_time }}</li>
          </ul>
        </li>
      </ul>
      <p class="sub-title">会员可在以下平台通用</p>
      <p class="sub-des">使用的软件版本、设备、操作系统等不同可能导致实际可使用的会员服务有差别</p>
      <ul class="platform">
        <li v-for="item in platform" :key="item.label">
          <svg-icon :name="item.icon" class="svg-icon"></svg-icon>
          <span>{{ item.label }}</span>
        </li>
      </ul>
      <ul class="info">
        <li v-for="item in info" :key="item.label">
          <a :href="item.link" target="_blank">
            <svg-icon :name="item.icon" class="svg-icon"></svg-icon>
            <p>{{ item.label }}</p>
            <span>了解更多></span>
          </a>
        </li>
      </ul>
    </div>
    <div class="warpper2" ref="rowHeadRef">
      <p class="title">权益对比</p>
      <div class="table">
        <ul class="row row-head" v-if="!isToTop">
          <li>
            <div class="title column first">功能</div>
            <div v-for="item in contrasTitleList" :key="item.name" :class="'column ' + item.class">
              <p class="title">{{ item.name }}</p>
              <p v-if="item.des" class="des">{{ item.des }}</p>
            </div>
          </li>
        </ul>
        <div class="kb" v-else></div>
        <div :class="[{ 'row-head-active': isToTop }]">
          <ul v-for="item in contrastList" :key="item.title" class="row rowbody">
            <li>
              <p class="title column first">{{ item.title }}</p>
            </li>
            <li v-for="i in item.list" :key="i.name">
              <div class="column first" v-html="i.name"></div>
              <div v-if="!i.register" class="column free">—</div>
              <div class="column free" v-else>
                <svg-icon name="right-bg" class="right-bg"></svg-icon>
              </div>

              <div v-if="!i.galleryvip" class="column galleryvip">—</div>
              <div class="column galleryvip" v-else>
                <svg-icon name="right-bg" class="right-bg"></svg-icon>
              </div>
              <div v-if="!i.minivip" class="column minivip">—</div>
              <div class="column minivip" v-else>
                <svg-icon name="right-bg" class="right-bg"></svg-icon>
              </div>
              <div v-if="!i.supervip" class="column supervip">—</div>
              <div class="column supervip" v-else>
                <svg-icon name="right-bg" class="right-bg"></svg-icon>
              </div>
              <div v-if="!i.threevip" class="column threevip">—</div>
              <div class="column threevip" v-else>
                <svg-icon name="right-bg" class="right-bg"></svg-icon>
              </div>
            </li>
          </ul>
        </div>
        <template v-if="isExpend">
          <ul v-for="item in contrastList3" :key="item.title" class="row rowfoot">
            <li>
              <p class="title column first">{{ item.title }}</p>
            </li>
            <li v-for="i in item.list" :key="i.name">
              <div class="column first">{{ i.name }}</div>
              <div class="column free">
                <p v-for="text in i.register" :key="text" class="text">{{ text }}</p>
              </div>
              <div class="column galleryvip">
                <p v-for="text in i.galleryvip" :key="text" class="text">{{ text }}</p>
              </div>
              <div class="column minivip">
                <p v-for="text in i.minivip" :key="text" class="text">{{ text }}</p>
              </div>
              <div class="column supervip">
                <p v-for="text in i.supervip" :key="text" class="text">{{ text }}</p>
              </div>
              <div class="column threevip">
                <p v-for="text in i.threevip" :key="text" class="text">{{ text }}</p>
              </div>
            </li>
          </ul>
        </template>
        <div class="row-mark" v-if="!isExpend"></div>
      </div>
      <div class="expend" v-if="!isExpend" @click="setExpend(true)">
        展开详细对比 <svg-icon name="expend" class="svg-icon"></svg-icon>
      </div>
      <div class="expend" v-else @click="setExpend(false)">
        收起详细对比 <svg-icon name="arrowclose" class="svg-icon"></svg-icon>
      </div>
    </div>
    <div class="warpper3">
      <p>常见问题</p>
      <ul class="questions">
        <li v-for="item in questions" :key="item.text">
          <a
            :href="linkURL1 + '/help.html?qa=' + item.url"
            target="_blank"
            rel="noopener noreferrer"
            >{{ item.text }}</a
          >
        </li>
      </ul>
    </div>
    <payMenber
      v-if="needPayMember"
      v-model:needPayMember="needPayMember"
      :needWhichOne="needWhichOne"
      @setPayMember="setPayMember"
    ></payMenber>
    <EquityContrast v-model:showThis="showEquity"></EquityContrast>

    <Footer></Footer>
    <SubNav></SubNav>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

// 组件路由守卫
export default defineComponent({
  beforeRouteEnter(to, from, next, e) {
    next(e => {
      if (from.name == 'cad_autologin') {
        const query = from.query
        if (query.url) {
          switch (query.url) {
            case '/cad/drawpay':
              e.payMenberFun('minivip')
              break
            case '/cad/gallery':
              e.payMenberFun('galleryvip')
              break
            case '/cad/sdrawpay':
              e.payMenberFun('supervip')
              break
            case '/cad/minisd':
              e.payMenberFun('threevip')
              break
            default:
              break
          }
          if (query.showLogin) {
            e.router.push({ path: '/cad', qeury: { showLogin: 'true' } })
          } else if (query.type) {
            e.router.push({ path: '/cad', query: { type: query.type } })
          } else {
            e.router.push('/cad')
          }
        }
      }
    })
  }
})
</script>

<script setup>
import payMenber from '@/components/cad/payMenber.vue'
import Header from '@/components/cad/Header.vue'
import Footer from '@/components/cad/Footer.vue'
import SubNav from '@/components/cad/SubNav.vue'
import EquityContrast from '@/components/cad/EquityContrast.vue'
import {
  menberList,
  platform,
  info,
  questions,
  contrastFree,
  contrastList1,
  contrastList2,
  contrastList3
} from '@/assets/js/data'
import { apiGetPrice } from '@/api/modules/cad_api'
import tool from '@/assets/js/tool'
import msg from '@/utils/message'
import { useMapState } from '@/assets/js/use_storemap'
import { useStore } from 'vuex'
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'

/* --- 全局变量 --- */
// vuex
const { isLogin, linkURL1, vipInfo } = useMapState({
  isLogin: state => state.isLogin,
  linkURL1: state => state.realm.linkURL1,
  vipInfo: state => state.userInfo.vip_info
})
const store = useStore()

const router = useRouter()
const route = useRoute()

const isExpend = ref(false) // 权益对比是否展开
const isToTop = ref(false) // 顶部是否显示
const rowHeadRef = ref(null)
const contrastList = ref([...contrastList1]) // 权益对比
const needPayMember = ref(false) // 购买会员
const needWhichOne = ref('') // 购买哪一个会员
const menberListAll = ref(tool.deepClone(menberList)) // 会员列表
const contrasTitleList = ref(tool.deepClone([contrastFree, ...menberList]))
let showEquity = ref(false)

onMounted(() => {
  setContrastList()

  window.addEventListener('scroll', throttledScroll)
  checkScrollPosition()
})

/* 被去除页面的路由该显示什么 */
const setPathTo = () => {
  switch (route.path) {
    case '/cad/drawpay':
      payMenberFun('minivip')
      break
    case '/cad/gallery':
      payMenberFun('galleryvip')
      break
    case '/cad/sdrawpay':
      payMenberFun('supervip')
      break
    case '/cad/minisd':
      payMenberFun('threevip')
      break
    case '/cad/reg':
      store.state.cad.login.show = true
      store.state.cad.login.type = 'register'
      break
    default:
      break
  }

  if (route.query.paykey) {
    payMenberFun(route.query.paykey)
  }

  if (route.query.type && route.query.type == 'equity') {
    showEquity.value = true
  }

  if (route.query.showLogin == 'true') {
    store.state.cad.login.show = true
    store.state.cad.login.type = 'byaccount'
  }

  if (route.name != 'cad_index') {
    router.push('/cad')
  } else {
    if (route.query.personal && route.query.personal == 'true') {
      return
    } else {
      router.push({
        path: route.path
      })
    }
  }
}

const setMenberList = () => {
  menberListAll.value = menberListAll.value.map(item => {
    const vipType = vipInfo.value[item.type]
    if (!vipType) {
      return { ...item, vip: false }
    }

    const vipStatus = vipType.code == 1

    return {
      ...item,
      vip: vipStatus,
      times: vipType.data || null
    }
  })
  contrasTitleList.value = reorderMemberList(tool.deepClone([contrastFree, ...menberListAll.value]))
}

onUnmounted(() => {
  window.removeEventListener('scroll', throttledScroll)
})

const checkScrollPosition = () => {
  if (!rowHeadRef.value) return
  const rect = rowHeadRef.value.getBoundingClientRect()
  isToTop.value = rect.top <= 0
}

const throttledScroll = tool.throttle(checkScrollPosition, 100)

const setContrastList = () => {
  if (isExpend.value) {
    contrastList.value = [...contrastList1, ...contrastList2]
  } else {
    contrastList.value = [...contrastList1]
  }
}
const setExpend = flag => {
  isExpend.value = flag
  setContrastList()
}

const payMenberFun = key => {
  if (!isLogin.value) {
    store.state.cad.login.show = true
    store.state.cad.login.type = 'byaccount'
    router.push({
      path: route.path, // 保持路径不变
      query: {
        ...route.query, // 保留现有参数
        paykey: key // 添加新参数
      }
    })
  } else {
    needWhichOne.value = key
    needPayMember.value = true
  }
}

const setPayMember = key => {
  needWhichOne.value = key
}

const getThePrice = async () => {
  const token = store.state.user.token

  try {
    const res = await apiGetPrice({ usertoken: token })
    if (res.code === 1) {
      store.state.cad.payPrice = res.param1
    } else {
      msg.e({ msg: '获取价格失败，请稍后再试~' })
    }
  } catch (error) {
    msg.e({ msg: '获取价格失败，请稍后再试~' })
  }
}

const setThePrice = async price => {
  let setPrice = tool.deepClone(menberList)
  setPrice.map(item => {
    if (item.type == 'vip') {
      item.price = price.vip.one.money
    } else if (item.type == 'svip') {
      item.price = price.svip.one.money
    }
  })
  menberListAll.value = setPrice
  contrasTitleList.value = reorderMemberList(tool.deepClone([contrastFree, ...menberListAll.value]))
}

function reorderMemberList(list) {
  // 创建副本以避免修改原数组
  return [...list].sort((a, b) => {
    if (a.type === 'galleryvip' && b.type === 'vip') {
      return -1 // galleryvip 排在 vip 前面
    } else if (a.type === 'vip' && b.type === 'galleryvip') {
      return 1 // vip 排在 galleryvip 后面
    }
    // 其他情况保持原顺序
    return 0
  })
}

watch(
  () => isLogin.value,
  async newVal => {
    let price = store.state.cad.payPrice

    if (newVal) {
      if (!price || Object.keys(price).length == 0) {
        await getThePrice()
        price = store.state.cad.payPrice
      }

      await setThePrice(price)
      setMenberList()
    } else {
      await getThePrice()
      price = store.state.cad.payPrice
      setThePrice(price)
    }

    setPathTo()
  },
  { immediate: true }
)

defineExpose({ router, payMenberFun, store })
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';
@import '@/assets/scss/_make.scss';
#home {
  font-family: 'SourceHanSansCN';
  font-weight: 400;
  @include responsive-style(
    (
      font-size: 14px
    )
  );
}

.row {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  @include responsive-style(
    (
      border-bottom: 1px solid #e5e5e5
    )
  );
  & > li {
    text-align: center;
    display: flex;
    align-items: center;
    .column {
      box-sizing: border-box;
      text-align: center;
      color: #585a5c;
      font-weight: 400;
      @include responsive-style(
        (
          padding: 6px 21px,
          font-size: 16px
        )
      );
      .right-bg {
        @include responsive-style(
          (
            width: 20px,
            height: 20px
          )
        );
      }
      &.first {
        align-self: self-start;
        text-align: start;
        @include responsive-style(
          (
            width: 200px
          )
        );
      }
      &.free,
      &.galleryvip,
      &.minivip {
        @include responsive-style(
          (
            width: 180px
          )
        );
      }
      &.supervip {
        @include responsive-style(
          (
            width: 240px
          )
        );
      }
      &.threevip {
        @include responsive-style(
          (
            width: 220px
          )
        );
      }
    }
    .title-box {
      @include responsive-style(
        (
          margin-bottom: 12px,
          height: 49px
        )
      );
    }

    .title {
      color: #000;
      font-weight: 700;
      @include responsive-style(
        (
          font-size: 20px
        )
      );
    }
    .des {
      color: #585a5c;
      font-weight: 400;
      @include responsive-style(
        (
          font-size: 14px
        )
      );
    }
    .text {
      color: #302e38;
      font-weight: 400;
      @include responsive-style(
        (
          font-size: 16px
        )
      );
    }
    .btn {
      margin: 0 auto;
      box-sizing: border-box;
      @include responsive-style(
        (
          width: 140px,
          height: 40px,
          margin-top: 12px
        )
      );
    }
  }
  &.row-head {
    @include responsive-style(
      (
        height: 70px
      )
    );
  }
  &.to-top {
    @include responsive-style(
      (
        height: 202px,
        padding-top: 22px
      )
    );
    & > li .column {
      @include responsive-style(
        (
          padding: 14px 21px
        )
      );
    }
  }
  &.rowbody {
    li {
      @include responsive-style(
        (
          height: 56px
        )
      );
    }
  }
  &.rowfoot {
    li {
      @include responsive-style(
        (
          height: 56px
        )
      );

      &:last-child {
        @include responsive-style(
          (
            height: 96px
          )
        );
      }

      .text {
        color: #585a5c;
        font-weight: 400;
        white-space: nowrap;
        @include responsive-style(
          (
            font-size: 12px
          )
        );
      }
    }
  }
}
.kb {
  @include responsive-style(
    (
      height: 100px
    )
  );
}
.warpper1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: radial-gradient(450% 50% at 50% 50%, #f5f7f9 0%, #f8fafd 100%);
  @include responsive-style(
    (
      padding: 110px 0 115px
    )
  );

  .title {
    color: #0f0f0f;
    font-weight: 700;

    @include responsive-style(
      (
        font-size: 58px,
        margin-bottom: 20px
      )
    );
  }

  .des {
    color: #585a5c;
    font-weight: 400;
    @include responsive-style(
      (
        font-size: 16px,
        margin-bottom: 60px
      )
    );
  }

  .member-list {
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
    @include responsive-style(
      (
        width: 1200px,
        margin-bottom: 60px,
        height: 526px
      )
    );

    & > li {
      background: #fff;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
      box-sizing: border-box;
      @include responsive-style(
        (
          width: 272px,
          padding: 43px 24px,
          border-radius: 20px
        )
      );
      .tips {
        position: absolute;
        transform: rotate(45deg);
        background: #facc8a;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #76401d;
        font-weight: 500;
        @include responsive-style(
          (
            width: 130px,
            right: -32px,
            top: 14px,
            height: 34px,
            font-size: 14px
          )
        );
      }

      .top {
        display: flex;
        flex-direction: column;
        align-items: center;
        @include responsive-style(
          (
            border-bottom: 1px solid #ededed,
            margin-bottom: 17px
          )
        );
        .svg-icon {
          @include responsive-style(
            (
              width: 56px,
              height: 56px
            )
          );
        }

        .name {
          color: #000;
          font-weight: 500;
          @include responsive-style(
            (
              font-size: 20px,
              margin-top: 16px,
              margin-bottom: 10px
            )
          );
        }
        .btn {
          @include responsive-style(
            (
              width: 225px,
              margin-bottom: 18px,
              margin-top: 20px
            )
          );
        }
      }
      .bottom {
        @include responsive-style(
          (
            padding: 10px
          )
        );
        & > li {
          display: flex;
          align-items: center;
          white-space: nowrap;
          @include responsive-style(
            (
              margin-bottom: 14px
            )
          );
          .svg-icon {
            @include responsive-style(
              (
                margin-right: 8px,
                width: 16px,
                height: 16px
              )
            );
          }
        }
      }
    }
  }

  .sub-title {
    color: #0f0f0f;
    font-weight: 500;
    @include responsive-style(
      (
        font-size: 32px,
        margin-bottom: 10px
      )
    );
  }

  .sub-des {
    color: #585a5c;
    font-weight: 400;
    @include responsive-style(
      (
        font-size: 14px,
        margin-bottom: 36px
      )
    );
  }

  .platform {
    display: flex;
    align-items: center;
    justify-content: center;
    li {
      display: flex;
      align-items: center;
      flex-direction: column;
      @include responsive-style(
        (
          margin-right: 50px,
          margin-bottom: 60px
        )
      );
      &:last-child {
        margin-right: 0;
      }

      .svg-icon {
        @include responsive-style(
          (
            width: 40px,
            height: 40px,
            margin-bottom: 5px
          )
        );
      }

      span {
        color: #585a5c;
        font-weight: 400;
        @include responsive-style(
          (
            font-size: 16px
          )
        );
      }
    }
  }

  .info {
    display: flex;
    justify-content: center;
    li {
      box-sizing: border-box;
      background: #fff;
      @include responsive-style(
        (
          margin-right: 60px,
          width: 328px,
          border-radius: 20px
        )
      );
      a {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        @include responsive-style(
          (
            padding: 32px 112px,
            border-radius: 20px
          )
        );
      }
      &:last-child {
        margin-right: 0;
      }

      &:hover {
        @include responsive-style(
          (
            box-shadow: 0px 4px 20px 4px rgba(94, 105, 115, 0.1)
          )
        );
      }

      .svg-icon {
        @include responsive-style(
          (
            width: 52px,
            height: 52px,
            margin-bottom: 14px
          )
        );
      }
      p {
        color: #0f0f0f;
        white-space: nowrap;
        font-weight: 500;
        @include responsive-style(
          (
            font-size: 24px,
            margin-bottom: 24px
          )
        );
      }
      span {
        color: #302e38;
        font-weight: 400;
        @include responsive-style(
          (
            font-size: 14px
          )
        );
      }
    }
  }
}

.warpper2 {
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  @include responsive-style(
    (
      padding: 110px 0 115px
    )
  );
  & > .title {
    color: #0f0f0f;
    font-weight: 500;
    @include responsive-style(
      (
        font-size: 40px,
        margin-bottom: 60px
      )
    );
  }

  .table {
    @include responsive-style(
      (
        width: 1200px
      )
    );
    position: relative;
    .row-mark {
      position: absolute;
      bottom: 0;
      left: 0;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, #fff 109.24%);
      @include responsive-style(
        (
          width: 1200px,
          height: 120px
        )
      );
    }
  }

  .expend {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000;
    font-weight: 400;
    box-sizing: border-box;
    cursor: pointer;
    @include responsive-style(
      (
        font-size: 16px,
        width: 152px,
        height: 48px,
        padding: 11px 14px,
        border-radius: 6px,
        border: 1px solid #e9e9e9,
        margin-top: 20px
      )
    );
    .svg-icon {
      @include responsive-style(
        (
          width: 14px,
          height: 14px,
          margin-left: 4px
        )
      );
    }
  }
}

.topBanner {
  position: fixed;
  width: 100%;
  display: flex;
  justify-content: center;
  background: #fff;
  z-index: 1;

  @include responsive-style(
    (
      top: 60px,
      box-shadow: 0px 2px 8px 0px rgba(120, 178, 225, 0.15),
      border-top: 1px solid #e3e5ed
    )
  );
}

.warpper1 ul li,
.warpper2 ul li .column,
.topBanner ul li .column {
  .price {
    color: #302e38;
    font-weight: 500;

    @include responsive-style(
      (
        font-size: 14px
      )
    );
    .num {
      font-weight: 700;
      @include responsive-style(
        (
          font-size: 32px
        )
      );
    }
    .unit {
      font-weight: 700;
    }
  }
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    box-sizing: border-box;
    position: relative;
    white-space: nowrap;

    @include responsive-style(
      (
        border-radius: 50px,
        padding: 7px 74px,
        font-size: 16px,
        line-height: 30px
      )
    );
    .mark {
      position: absolute;
      width: 100%;
      height: 100%;
      display: none;
      opacity: 0.12;
      background: #fff;
    }
    &:hover {
      .mark {
        display: block;
      }
    }
  }
  &.free {
    .btn {
      cursor: default;

      &:hover {
        .mark {
          display: none;
        }
      }
    }
  }
  &.minivip {
    .btn {
      background: linear-gradient(92deg, #fad096 7.97%, #fac67d 97.7%);
      color: #76401d;
    }
  }
  &.galleryvip {
    .btn {
      color: #76401d;
      background: linear-gradient(92deg, #fadd8c 8.57%, #fad97d 97.12%);
    }
  }
  &.supervip {
    .btn {
      color: #f5f5f5;
      background: linear-gradient(149deg, #361d20 15.82%, #361d20 87.58%);
      .mark {
        opacity: 0.1;
      }
    }
  }
  &.threevip {
    .btn {
      color: #f5f5f5;
      background: linear-gradient(137deg, #326ffa 9.16%, #1756e5 94%);
    }
  }
}

.topBanner ul li .column {
  .price {
    .num {
      @include responsive-style(
        (
          font-size: 20px
        )
      );
    }
  }
}

.warpper3 {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 110px 0;
  background: radial-gradient(450% 50% at 50% 50%, #f5f7f9 0%, #f8fafd 100%);

  & > p {
    color: #0f0f0f;
    font-weight: 500;
    @include responsive-style(
      (
        font-size: 40px,
        margin-bottom: 60px
      )
    );
  }
  .questions {
    li {
      list-style: disc;
      @include responsive-style(
        (
          margin-bottom: 24px
        )
      );
      &:last-child {
        margin-bottom: 0;
      }
      a {
        color: #302e38;
        font-size: 20px;
        font-weight: 400;
        @include responsive-style(
          (
            font-size: 20px
          )
        );
      }
    }
  }
}
</style>
